import {HomeLink} from '../links';
import {LearnerExploreGroup, LearnerFooterGroup, LearnerMonitoringAndStatisticsGroup} from '../groups';
import {NavigationContext} from '../navigation.context';

export const LearnerMenu = (context: NavigationContext) => [
    HomeLink(context),
    LearnerMonitoringAndStatisticsGroup(context),
    LearnerExploreGroup(context),
    LearnerFooterGroup(context)
];

